<template>
  <img
    :alt="$t.locationSelectorCurrentCountry"
    height="12"
    loading="lazy"
    :src="`/img/flags/${flagCountryCode}.svg`"
    width="18"
  >
</template>

<script lang="ts" setup>
const props = defineProps<{ countryCode?: string }>()

const defaultCountryCode = useCountryCode()
const flagCountryCode = computed(() => (props.countryCode || defaultCountryCode).toUpperCase())
</script>
